import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { LiveChannelsDataService, LiveChannelsColumnsService } from '../../../services';
import { LiveChannel, LiveChannelsResult } from '../../../interfaces';

@Component({
  selector: 'app-live-channel-form',
  templateUrl: './live-channel-form.component.html',
  styleUrls: ['./live-channel-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class LiveChannelFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public liveChannel: LiveChannel = {};
  public liveChannelForm: FormGroup = new FormGroup({});
  public liveChannels: LiveChannel[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private liveChannelsDataService: LiveChannelsDataService,
    public liveChannelsColumnsService: LiveChannelsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'LiveChannelFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Live Channel - Edit');
        this.getLiveChannel(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.liveChannel !== 'undefined') {
      this.liveChannel = this.dynamicDialogConfig.data.liveChannel;
    }
    if (typeof this.liveChannel.id === 'undefined' || this.liveChannel.id === null) {
      this.liveChannel.id = null;
      this.liveChannel.putOnHome = false;
      this.liveChannel.enableStreaming = false;
      this.liveChannel.autoPublishing = false;
      this.liveChannel.startPublishing = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
      this.liveChannel.endPublishing = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
    }
    this.getLiveChannels();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'LiveChannelFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'LiveChannelFormComponent');
  }

  getLiveChannel(id: number): void {
    this.isLoading = true;
    this.liveChannelsDataService.getLiveChannel(id).subscribe((response: LiveChannel|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.liveChannel = response;
        this.prepareFrom();
      }
    });
  }

  getLiveChannels(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.liveChannels !== 'undefined' && this.dynamicDialogConfig.data.liveChannels.length > 0) {
      this.liveChannels = this.dynamicDialogConfig.data.liveChannels;
      return;
    }
    this.liveChannelsDataService.getLiveChannels(this.parameters).subscribe((response: LiveChannelsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.liveChannels = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.liveChannel.startPublishing = moment(this.liveChannel.startPublishing).toDate();
    this.liveChannel.endPublishing = moment(this.liveChannel.endPublishing).toDate();
    this.liveChannelForm = new FormGroup({
      price: new FormControl((typeof this.liveChannel.price === 'number') ? this.liveChannel.price : this.liveChannel.price?.id, [Validators.required, ]),
      sharing: new FormControl((typeof this.liveChannel.sharing === 'number') ? this.liveChannel.sharing : this.liveChannel.sharing?.id, [Validators.required, ]),
      name: new FormControl(this.liveChannel.name, [Validators.required, ]),
      slug: new FormControl(this.liveChannel.slug, [Validators.required, ]),
      nameAr: new FormControl(this.liveChannel.nameAr, []),
      slugAr: new FormControl(this.liveChannel.slugAr, []),
      nameFr: new FormControl(this.liveChannel.nameFr, []),
      slugFr: new FormControl(this.liveChannel.slugFr, []),
      streamName: new FormControl(this.liveChannel.streamName, []),
      enableStreaming: new FormControl(this.liveChannel.enableStreaming, [Validators.required, ]),
      putOnHome: new FormControl(this.liveChannel.putOnHome, [Validators.required, ]),
      autoPublishing: new FormControl(this.liveChannel.autoPublishing, [Validators.required, ]),
      startPublishing: new FormControl(this.liveChannel.startPublishing, []),
      endPublishing: new FormControl(this.liveChannel.endPublishing, []),
      status: new FormControl(this.liveChannel.status, [Validators.required, ]),
      totalViews: new FormControl(this.liveChannel.totalViews, []),
      totalHits: new FormControl(this.liveChannel.totalHits, []),
      totalComments: new FormControl(this.liveChannel.totalComments, []),
      totalRatings: new FormControl(this.liveChannel.totalRatings, []),
      averageRatings: new FormControl(this.liveChannel.averageRatings, []),
      totalLikes: new FormControl(this.liveChannel.totalLikes, []),
      totalDislikes: new FormControl(this.liveChannel.totalDislikes, []),
      totalBookmarks: new FormControl(this.liveChannel.totalBookmarks, []),
      id: new FormControl(this.liveChannel.id, []),
    });
  }

  list() {
    this.router.navigate(['/live-channels']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.liveChannelForm.controls).forEach((field: any) => {
        const control = this.liveChannelForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.liveChannelForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.liveChannel = this.liveChannelForm.value;
    this.disableSubmit = true;
    console.log('liveChannel', this.liveChannel);
    if (typeof this.liveChannel.id !== 'undefined' && this.liveChannel.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.liveChannelsDataService.updateLiveChannel(this.liveChannel).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('LIVECHANNELUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('LIVECHANNELNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.liveChannelsDataService.addLiveChannel(this.liveChannel).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('LIVECHANNELCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('LIVECHANNELNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-live-channel-form',
  templateUrl: './live-channel-form.component.html',
  styleUrls: ['./live-channel-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogLiveChannelFormComponent extends LiveChannelFormComponent {
}

